import { Injectable } from '@angular/core';

const ORG_KEY = 'mila_org_slug';
// Lets a public, unauthenticated route (the docs see
// DocsApiReferenceDetail) know whether *this browser* last saw a
// Cikisi-connected organization, without either calling GET /me itself
// (docs deliberately have no authGuard/network dependency) or reaching
// into SessionService's in-memory state, which is empty on a fresh tab
// that never hit an authenticated route. Same lifecycle as ORG_KEY:
// written in SessionService.loadMe(), cleared in AuthService.logout().
// A stale "true" left over from a previous org on the same browser is
// the acceptable failure mode here it only ever gates *showing* extra
// documentation, never a real permission check.
const IS_CIKISI_USER_KEY = 'mila_is_cikisi_user';

/** Tracks which organization is active across a session nothing to do
 *  with authentication. The session itself lives entirely in an httpOnly
 *  cookie the backend manages; this app never stores or reads a token at
 *  all (see AuthInterceptor / SessionService for why). This service used
 *  to be TokenStorageService, back when the JWT itself lived in
 *  localStorage renamed once that stopped being true, since keeping the
 *  old name would have been actively misleading. */
@Injectable({ providedIn: 'root' })
export class OrgContextService {
  getOrgSlug(): string | null {
    return localStorage.getItem(ORG_KEY);
  }

  setOrgSlug(slug: string): void {
    localStorage.setItem(ORG_KEY, slug);
  }

  getIsCikisiUser(): boolean {
    return localStorage.getItem(IS_CIKISI_USER_KEY) === 'true';
  }

  setIsCikisiUser(value: boolean): void {
    localStorage.setItem(IS_CIKISI_USER_KEY, String(value));
  }

  clear(): void {
    localStorage.removeItem(ORG_KEY);
    localStorage.removeItem(IS_CIKISI_USER_KEY);
  }
}
